import { useState } from "react";

// Rechnungen werden separat über eine eigene Lösung bereitgestellt.
// Diese Datei ist ein Platzhalter für die künftige Implementierung.

const useInvoicesData = () => {
  const [invoices] = useState([]);

  return {
    columns: [
      { Header: "Rechnungsnummer", accessor: "voucherNumber" },
      { Header: "Datum", accessor: "voucherDate" },
      { Header: "Betrag", accessor: "totalAmount" },
      { Header: "Status", accessor: "status" },
    ],
    rows: invoices,
  };
};

export default useInvoicesData;
